import React, { useEffect, useRef } from 'react';
import './css/Projects.css';
import { translateProjetos } from '../../data/translateProjetos';

// 1. Importações obrigatórias do Glide
import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';

const uiText = {
  pt: {
    titulo: "PROJETOS",
    descricao: "Uma seleção de projetos pessoais, acadêmicos e corporativos que demonstram minhas habilidades em back-end, front-end e resolução de problemas.",
    verGithub: "GitHub",
    verDemo: "Demo",
    verExe: ".exe",
    verTodos: "Ver todos os repositórios"
  },
  en: {
    titulo: "PROJECTS",
    descricao: "A selection of personal, academic, and corporate projects that demonstrate my skills in back-end, front-end, and problem-solving.",
    verGithub: "GitHub",
    verDemo: "Demo",
    verExe: ".exe",
    verTodos: "View all repositories"
  }
};

const formatarClasseTag = (tag) => {
    const nomeFormatado = tag.toLowerCase()
        .replace('#', 'sharp') 
        .replace('.', '')      
        .replace(/\s+/g, '-'); 
    
    return `tag tag-${nomeFormatado}`;
};

function Projects({ language }) {
    const ui = uiText[language];
    
    // 2. Referência para o container do carrossel
    const glideRef = useRef(null);

    // 3. Inicialização do Glide no useEffect
    useEffect(() => {
        if (glideRef.current) {
            const glide = new Glide(glideRef.current, {
                type: 'carousel',
                perView: 4,         // Equivalente ao slidesPerView
                gap: 50,            // Equivalente ao spaceBetween
                autoplay: 2500,     // Equivalente ao autoplay
                hoverpause: true,   // Pausa ao passar o mouse por cima
                breakpoints: {
                    1024: { perView: 2 }, // Responsividade automática (opcional)
                    768: { perView: 1 }
                }
            });

            glide.mount();

            // Limpa a instância quando o componente for desmontado para evitar bugs
            return () => glide.destroy();
        }
    }, []);

    return (
        <section className="projects-section" id="projects">
            <div className='box-title-section'>
              <p className='back-legend'>{ui.titulo}</p>
              <h2 className='front-legend'>{ui.titulo}</h2>
            </div>
            
            <div className="projects-container">
                <div className="projects-header">
                    {/* <p className="projects-desc">
                        {ui.descricao}
                    </p> */}
                </div>

                <div className="projects-grid">
                    {/* 4. Estrutura HTML OBRIGATÓRIA do Glide */}
                    <div className="glide" ref={glideRef}>
                        <div className="glide__track" data-glide-el="track">
                            <div className="glide__slides">
                                
                                {translateProjetos.map((projeto) => (
                                    // A class glide__slide substitui o SwiperSlide
                                    <div className="glide__slide" key={projeto.Id}>
                                        
                                        {/* SEU CÓDIGO INTACTO A PARTIR DAQUI */}
                                        <div className="project-card">
                                            <div className={`card-top-bar bar-${projeto.CorTema}`}></div>
                                            
                                            <div className="card-content">
                                                <div className="card-icons">
                                                    <div className={`icon-box ${projeto.CorTema}-box`}>
                                                        <span className="material-icons-outlined">{projeto.Icone}</span>
                                                    </div>
                                                    <a href={projeto.LinkGit} target="_blank" rel="noreferrer" className="github-link">
                                                        <i className="fab fa-github"></i>
                                                    </a>
                                                </div>
                                                
                                                <h4 className="card-title">{projeto.Nome[language]}</h4>
                                                <p className="card-text">{projeto.Descricao[language]}</p>
                                                
                                                <div className="card-footer">
                                                    <div className="tech-tags">
                                                        {projeto.Tags.map((tag, index) => (
                                                            <span key={index} className={formatarClasseTag(tag)}>
                                                                {tag}
                                                            </span>
                                                        ))}
                                                    </div>
                                                    
                                                    <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                                                        {projeto.LinkGit && (
                                                            <a href={projeto.LinkGit} target="_blank" rel="noreferrer" className="btn-repo">
                                                                <i className="fab fa-github"></i> {ui.verGithub}
                                                            </a>
                                                        )}
                                                        
                                                        {projeto.LinkDemo && (
                                                            <a href={projeto.LinkDemo} target="_blank" rel="noreferrer" className="btn-repo"
                                                                style={{ backgroundColor: 'transparent', border: '1px solid var(--text-secondary)'}}>
                                                                <i className="fas fa-external-link-alt"></i> {ui.verDemo}
                                                            </a>
                                                        )}

                                                        {projeto.LinkExe && (
                                                            <a href={projeto.LinkExe} target="_blank" rel="noreferrer" className="btn-repo">
                                                                <i className="fab fa-github"></i> {ui.verExe}
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* FIM DO SEU CÓDIGO INTACTO */}
                                        
                                    </div>
                                ))}
                                
                            </div>
                        </div>
                    </div>
                    {/* Fim da Estrutura do Glide */}
                </div>

                <div className="projects-action">
                    <a href="https://github.com/tiagolucasoo" target="_blank" rel="noreferrer" className="view-all-link">
                        {ui.verTodos}
                    </a>
                </div>
            </div>
        </section>
    );
}

export default Projects;